// Central date/time formatting so the whole app is consistent: all
// timestamps are displayed in IST (Asia/Kolkata), 12-hour clock, and dates
// as dd/mm/yyyy — regardless of the server's or browser's own timezone.
// The backend already stores/serves timezone-aware datetimes (Django
// USE_TZ=True, TIME_ZONE="Asia/Kolkata"), so we just need to render them
// consistently here rather than relying on the browser's locale/timezone.

const IST_TIME_ZONE = 'Asia/Kolkata'

/** e.g. "17/07/2026" */
export function formatDate(value: string | Date | null | undefined): string {
  if (!value) return '—'
  const date = value instanceof Date ? value : new Date(value)
  if (isNaN(date.getTime())) return '—'
  return new Intl.DateTimeFormat('en-GB', {
    timeZone: IST_TIME_ZONE,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(date)
}

/** e.g. "02:45 PM" */
export function formatTime(value: string | Date | null | undefined): string {
  if (!value) return '—'
  const date = value instanceof Date ? value : new Date(value)
  if (isNaN(date.getTime())) return '—'
  return new Intl.DateTimeFormat('en-US', {
    timeZone: IST_TIME_ZONE,
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  }).format(date)
}

/** e.g. "02:45:09 PM" — for a live-ticking clock display, not for timestamps. */
export function formatTimeWithSeconds(value: string | Date | null | undefined): string {
  if (!value) return '—'
  const date = value instanceof Date ? value : new Date(value)
  if (isNaN(date.getTime())) return '—'
  return new Intl.DateTimeFormat('en-US', {
    timeZone: IST_TIME_ZONE,
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
  }).format(date)
}

/** e.g. "17/07/2026, 02:45 PM" */
export function formatDateTime(value: string | Date | null | undefined): string {
  if (!value) return '—'
  return `${formatDate(value)}, ${formatTime(value)}`
}

/** Today's date as yyyy-mm-dd in IST, for <input type="date"> and API params. */
export function todayISO(): string {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: IST_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(new Date())
  const map: Record<string, string> = {}
  parts.forEach((p) => (map[p.type] = p.value))
  return `${map.year}-${map.month}-${map.day}`
}



// // Central date/time formatting so the whole app is consistent: all
// // timestamps are displayed in IST (Asia/Kolkata), 12-hour clock, and dates
// // as dd/mm/yyyy — regardless of the server's or browser's own timezone.
// // The backend already stores/serves timezone-aware datetimes (Django
// // USE_TZ=True, TIME_ZONE="Asia/Kolkata"), so we just need to render them
// // consistently here rather than relying on the browser's locale/timezone.

// const IST_TIME_ZONE = 'Asia/Kolkata'

// /** e.g. "17/07/2026" */
// export function formatDate(value: string | Date | null | undefined): string {
//   if (!value) return '—'
//   const date = value instanceof Date ? value : new Date(value)
//   if (isNaN(date.getTime())) return '—'
//   return new Intl.DateTimeFormat('en-GB', {
//     timeZone: IST_TIME_ZONE,
//     day: '2-digit',
//     month: '2-digit',
//     year: 'numeric',
//   }).format(date)
// }

// /** e.g. "02:45 PM" */
// export function formatTime(value: string | Date | null | undefined): string {
//   if (!value) return '—'
//   const date = value instanceof Date ? value : new Date(value)
//   if (isNaN(date.getTime())) return '—'
//   return new Intl.DateTimeFormat('en-US', {
//     timeZone: IST_TIME_ZONE,
//     hour: '2-digit',
//     minute: '2-digit',
//     hour12: true,
//   }).format(date)
// }

// /** e.g. "17/07/2026, 02:45 PM" */
// export function formatDateTime(value: string | Date | null | undefined): string {
//   if (!value) return '—'
//   return `${formatDate(value)}, ${formatTime(value)}`
// }

// /** Today's date as yyyy-mm-dd in IST, for <input type="date"> and API params. */
// export function todayISO(): string {
//   const parts = new Intl.DateTimeFormat('en-CA', {
//     timeZone: IST_TIME_ZONE,
//     year: 'numeric',
//     month: '2-digit',
//     day: '2-digit',
//   }).formatToParts(new Date())
//   const map: Record<string, string> = {}
//   parts.forEach((p) => (map[p.type] = p.value))
//   return `${map.year}-${map.month}-${map.day}`
// }